(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { isNumber } from "../../../utils/number";
import { pipe } from "../../../utils/fp";
import { flatten } from "../../../utils/array";

const addShortCode = codes => codes === null || codes === void 0 ? void 0 : codes.map(c => ({ ...c,
  shortCode: c.code.slice(6),
  children: c.children ? addShortCode(c.children) : null
})); // Title is code.level in [5, 7, 9]


const sortByTitle = function () {
  let collections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return collections === null || collections === void 0 ? void 0 : collections.sort((a, b) => {
    if (!a.children && b.children) {
      return b.children.length ? Number(a.code) - Number(b.children[0].code) : -1;
    }

    if (a.children && !b.children) {
      return a.children.length ? Number(a.children[0].code) - Number(b.code) : 1;
    }

    return 0;
  });
};

const sortByCodes = function () {
  let collections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return collections === null || collections === void 0 ? void 0 : collections.sort((a, b) => Number(a.hsCode || a.code) - Number(b.hsCode || b.code)).map(item => ({ ...item,
    children: Array.isArray(item.children) ? sortByCodes(item.children) : null
  }));
};

const sortByProbability = function () {
  let collections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return collections === null || collections === void 0 ? void 0 : collections.sort((a, b) => b.probability - a.probability);
};

export const compressHsCodes = function (codes) {
  let parentCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return codes === null || codes === void 0 ? void 0 : codes.reduce((acc, code) => {
    if (!code.children) {
      return [...acc, code];
    }

    const headingChildren = code.children.filter(child => Array.isArray(child.children) && child.children.length);
    const children = code.children.filter(child => !Array.isArray(child.children));

    if (children.length) {
      const description = [...parentCodes, code].map(c => c.description).join("; ");
      acc.push({ ...code,
        description,
        children
      });
    }

    if (headingChildren.length) {
      acc.push(compressHsCodes(headingChildren, [...parentCodes, code]));
    }

    return flatten(acc);
  }, []);
};
export const normalizeHsCodes = codes => ({ ...codes,
  predictions: sortByProbability(codes.predictions).map(p => ({ ...p,
    probability: isNumber(Number(p.probability)) ? p.probability.toFixed(2) : "",
    children: pipe(sortByCodes, sortByTitle, addShortCode, compressHsCodes)(p.children)
  }))
});
export const normalizeCountries = countries => countries.sort((a, b) => a.label > b.label ? 1 : -1);
export const normalizeHistory = history => Object.values(history.sort((a, b) => b.searchId - a.searchId).reduce((acc, item) => {
  const key = "".concat(item.query, "_").concat(item.country);

  if (!acc[key]) {
    acc[key] = item;
  }

  return acc;
}, {}));
export const normalizeHsCodeDetails = details => ({ ...details,
  children: pipe(sortByTitle, compressHsCodes)(details.children)
});
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(addShortCode, "addShortCode", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(sortByTitle, "sortByTitle", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(sortByCodes, "sortByCodes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(sortByProbability, "sortByProbability", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(compressHsCodes, "compressHsCodes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(normalizeHsCodes, "normalizeHsCodes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(normalizeCountries, "normalizeCountries", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(normalizeHistory, "normalizeHistory", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
  reactHotLoader.register(normalizeHsCodeDetails, "normalizeHsCodeDetails", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/dataProvider/normalize.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();